import { CONTACT } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";
import { ArrowUpRight } from "lucide-react";

export const Contact = () => (
  <section
    id="kontakt"
    data-testid="contact-section"
    className="bg-[#1f3d2b] text-white pt-28 md:pt-40 pb-12"
  >
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <Reveal>
        <p className="font-ui text-[11px] uppercase tracking-[0.3em] text-[#8fae9b] mb-10 flex items-center gap-3">
          <span className="inline-block h-px w-8 bg-[#8fae9b]" />
          Kontakt
        </p>
      </Reveal>

      <Reveal delay={0.05}>
        <h2 className="font-display font-light leading-[0.95] text-[15vw] md:text-[10rem] lg:text-[12rem] tracking-tight">
          Lad os tale
          <br />
          <span className="italic text-[#c8dccf]">sammen.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-white/15 pt-12">
        <Reveal>
          <div className="font-ui text-xs uppercase tracking-[0.2em] text-[#8fae9b] mb-3">
            E-mail
          </div>
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="contact-email"
            className="font-display text-2xl md:text-3xl text-white hover:text-[#c8dccf] transition-colors duration-300 break-all"
          >
            {CONTACT.email}
          </a>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="font-ui text-xs uppercase tracking-[0.2em] text-[#8fae9b] mb-3">
            Telefon
          </div>
          <a
            href={CONTACT.phoneHref}
            data-testid="contact-phone"
            className="font-display text-2xl md:text-3xl text-white hover:text-[#c8dccf] transition-colors duration-300"
          >
            {CONTACT.phone}
          </a>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="font-ui text-xs uppercase tracking-[0.2em] text-[#8fae9b] mb-3">
            LinkedIn
          </div>
          <a
            href={CONTACT.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-linkedin"
            className="font-display text-2xl md:text-3xl text-white inline-flex items-center gap-2 hover:text-[#c8dccf] transition-colors duration-300"
          >
            Se profil
            <ArrowUpRight size={22} />
          </a>
        </Reveal>
      </div>

      <div className="mt-24 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-white/15 pt-8">
        <div className="font-display text-xl">Morten Junge Bertelsen</div>
        <div className="font-ui text-xs uppercase tracking-[0.18em] text-[#8fae9b]">
          {CONTACT.location} · © {new Date().getFullYear()}
        </div>
      </div>
    </div>
  </section>
);
